<template>
	<v-card>
		<BidderMonitoringList/>
	</v-card>
</template>

<script>
	import BidderMonitoringList from "./BidderMonitoringList";

	export default {
		name: "BidderMonitoringView",
		components: {
			BidderMonitoringList
		}
	};
</script>

<style scoped>

</style>
